import FreshWatchListEntities from '../../../customized/fresh-watch/components/DeviceManager/ListEntities/FreshWatchListEntities';
import { ToggleComponent } from '../../../featureToggle';
import ListEntities from './ListEntities';

export * from './ListEntities';

export default ToggleComponent(ListEntities, {
  styledComponentsVariants: {
    'fresh-watch': FreshWatchListEntities,
  },
});
